import { render, staticRenderFns } from "./RecommendCard.vue?vue&type=template&id=64f1d168&scoped=true"
import script from "./RecommendCard.vue?vue&type=script&lang=js"
export * from "./RecommendCard.vue?vue&type=script&lang=js"
import style0 from "./RecommendCard.vue?vue&type=style&index=0&id=64f1d168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1d168",
  null
  
)

export default component.exports